import { useContext } from "react";
import { CircularProgress, Typography } from "@mui/material";
import AdminTechpack from "../../components/AdminTechpack/AdminTeckpack";
import { useTranslation } from "react-i18next";
import { usePageTitle } from "../../common/hooks/usePageTitle";
import { Box } from "../../common/components";
import { AdminTechpackContext } from "../../context/Admin/Techpack";

const AdminTechpackOrder = () => {
  const { t } = useTranslation();
  usePageTitle("pages.techpack.title");
  const { isTeckpackLoaded, teckpackDetails } =
    useContext(AdminTechpackContext);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box sx={{ height: "100%" }}>
        {isTeckpackLoaded ? (
          teckpackDetails === null ? (
            <Typography variant="h6">{t("techpack.not_found")}</Typography>
          ) : (
            <AdminTechpack />
          )
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AdminTechpackOrder;
